module.exports = __webpack_public_path__ + "static/img/02.7f76254.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/bruderertrans/02.jpg
// module id = 359
// module chunks = 1